export default __webpack_public_path__ + "static/media/bg-earth.c116c22e.svg";